const formSections = {
  PATIENT_SECTION: "patient",
  INSURANCE_SECTION: "insurance",
  PRACTICE_SECTION: "practice"
};

export { formSections };
